import { useRef } from "react";

import { offset } from "@floating-ui/dom";

import { useFloatingWindowsActions } from "src/base-components/FloatingWindow/hooks";
import { type ComputePositionOptions } from "src/base-components/FloatingWindow/positioning";
import { FileAttributes } from "src/clients/files";

const DEFAULT_FILE_VIEWER_POSITION: ComputePositionOptions = {
  placement: "left-start",
  middleware: [offset({ mainAxis: 60, crossAxis: 0 })],
};

export const CaseFileCard: React.FC<{
  fileId: string;
  positionOptions?: ComputePositionOptions;
  children: (onView: (file: FileAttributes | File) => void) => React.ReactNode;
}> = ({ fileId, positionOptions = DEFAULT_FILE_VIEWER_POSITION, children }) => {
  const { open } = useFloatingWindowsActions();
  const cardRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={cardRef}>
      {children((file) =>
        open(
          {
            id: `file-viewer-${fileId}`,
            type: "cm-file",
            target: cardRef,
            positionOptions,
          },
          { file },
        ),
      )}
    </div>
  );
};
